import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { Switch, Route } from 'react-router'
import Layout from '../../common/layout/layout'
import JobListing from './listing'

const Jobs = () => {
  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Switch>
            <Route exact path="/jobs" component={JobListing} />
          </Switch>
        </Col>
      </Row>
    </Layout>
  )
}

export default Jobs
